import { all_routes } from "../../Router/all_routes";
import { routeRolesMap } from "../../Router/router"; // 👈 Import the same map

// helper: check if current userRole is allowed for a route
const isAllowed = (route, userRole) => {
  const allowedRoles = routeRolesMap[route] || ["Admin", "Manager", "Employee"];
  return allowedRoles.includes(userRole);
};

export const getSidebarData = (userRole) => {
  const sidebarData = [];

  // Dashboard
  if (isAllowed(all_routes.index, userRole)) {
    sidebarData.push({
      link: "/index",
      icon: "home",
      submenu: true,
      submenuItems: [
        {
          label: "Dashboard",
          link: "/index",
          icon: "home",
          submenu: false,
        },
      ],
    });
  }

  // Orders
  const orderItems = [];
  if (isAllowed(all_routes.neworders, userRole)) {
    orderItems.push({
      label: "Sales Order",
      link: all_routes.neworders,
      icon: "clipboard-plus",
    });
  }
  if (isAllowed(all_routes.allorder, userRole)) {
    orderItems.push({
      label: "All Orders",
      link: all_routes.allorder,
      icon: "arrows-sort",
    });
  }
  if (orderItems.length > 0) {
    sidebarData.push({
      label: "Orders",
      submenuHdr: "Orders",
      submenu: true,
      submenuItems: orderItems,
    });
  }

  // Inventory
  const inventoryItems = [];
  if (isAllowed(all_routes.inventory, userRole)) {
    inventoryItems.push({
      label: "Inventory",
      link: all_routes.inventory,
      icon: "search",
    });
  }
  if (isAllowed(all_routes.categorylist, userRole)) {
    inventoryItems.push({
      label: "Models",
      link: all_routes.categorylist,
      icon: "list-check",
    });
  }
  if (isAllowed(all_routes.brandlist, userRole)) {
    inventoryItems.push({
      label: "Brand",
      link: all_routes.brandlist,
      icon: "tags",
    });
  }
  if (isAllowed(all_routes.product, userRole)) {
    inventoryItems.push({
      label: "Products",
      link: all_routes.product,
      icon: "box",
    });
  }
  if (isAllowed(all_routes.partlist, userRole)) {
    inventoryItems.push({
      label: "Parts List",
      link: all_routes.partlist,
      icon: "stack-3",
    });
  }
  if (isAllowed(all_routes.customerlist, userRole)) {
    inventoryItems.push({
      label: "Customers",
      link: all_routes.customerlist,
      icon: "users",
    });
  }
  if (isAllowed(all_routes.transportlist, userRole)) {
    inventoryItems.push({
      label: "Transport",
      link: all_routes.transportlist,
      icon: "truck",
    });
  }
  if (inventoryItems.length > 0) {
    sidebarData.push({
      label: "Inventory",
      submenuHdr: "Inventory",
      submenu: true,
      submenuItems: inventoryItems,
    });
  }

  // Stock
  const stockItems = [];
  if (isAllowed(all_routes.managestock, userRole)) {
    stockItems.push({
      label: "Manage Stock",
      link: all_routes.managestock,
      icon: "stack-3",
    });
  }
  if (isAllowed(all_routes.addstocks, userRole)) {
    stockItems.push({
      label: "Add Stock",
      link: all_routes.addstocks,
      icon: "stack-push",
    });
  }
  if (isAllowed(all_routes.purchaseorder, userRole)) {
    stockItems.push({
      label: "Purchase Invoice",
      link: all_routes.purchaseorder,
      icon: "clipboard-plus",
    });
  }
  if (stockItems.length > 0) {
    sidebarData.push({
      label: "Stock",
      submenuHdr: "Stock",
      submenu: true,
      submenuItems: stockItems,
    });
  }

  // Management (all "Add" routes in one place)
  const managementItems = [];
  if (isAllowed(all_routes.addcategory, userRole)) {
    managementItems.push({
      label: "Add Model",
      link: all_routes.addcategory,
      icon: "plus",
    });
  }
  if (isAllowed(all_routes.addpart, userRole)) {
    managementItems.push({
      label: "Add Part",
      link: all_routes.addpart,
      icon: "plus",
    });
  }
  if (isAllowed(all_routes.partsmodels, userRole)) {
    managementItems.push({
      label: "Common Parts + Models",
      link: all_routes.partsmodels,
      icon: "plus",
    });
  }
  if (isAllowed(all_routes.addcustomer, userRole)) {
    managementItems.push({
      label: "Add Customer",
      link: all_routes.addcustomer,
      icon: "plus",
    });
  }
  if (isAllowed(all_routes.addtransport, userRole)) {
    managementItems.push({
      label: "Add Transport",
      link: all_routes.addtransport,
      icon: "plus",
    });
  }
  if (isAllowed(all_routes.adduser, userRole)) {
    managementItems.push({
      label: "Add User",
      link: all_routes.adduser,
      icon: "plus",
    });
  }
  if (isAllowed(all_routes.addvendors, userRole)) {
    managementItems.push({
      label: "Add Vendor",
      link: all_routes.addvendors,
      icon: "plus",
    });
  }

  if (managementItems.length > 0) {
    sidebarData.push({
      label: "Management",
      submenuHdr: "Management",
      submenu: true,
      submenuItems: managementItems,
    });
  }

  // Reports
  const reportItems = [];
  if (isAllowed(all_routes.salesreport, userRole)) {
    reportItems.push({
      label: "Sales Report",
      link: all_routes.salesreport,
      icon: "chart-bar",
    });
  }
  if (isAllowed(all_routes.purchasereport, userRole)) {
    reportItems.push({
      label: "Purchase Report",
      link: all_routes.purchasereport,
      icon: "chart-pie-2",
    });
  }
  // if (isAllowed(all_routes.inventoryreport, userRole)) {
  //   reportItems.push({
  //     label: "Inventory Report",
  //     link: all_routes.inventoryreport,
  //     icon: "triangle-inverted",
  //   });
  // }
  if (reportItems.length > 0) {
    sidebarData.push({
      label: "Reports",
      submenuHdr: "Reports",
      submenu: true,
      submenuItems: reportItems,
    });
  }

  return sidebarData;
};
